import React from "react";
import * as routes from "constants/routes";
import {
  Users,
  Tickets,
  LayoutDashboard,
  HandCoins,
  Settings,
  NotebookText,
  DatabaseZap,
  UserCheck,
  GitBranch,
  Layers2,
  Locate,
  ScrollText,
  Truck,
  BookUser,
  Newspaper,
} from "lucide-react";

interface SubMenuItem {
  title: string;
  to?: string;
  icon?: any;
  policy?: string;
}

interface MenuItem {
  name: string;
  to?: string;
  icon?: any;
  policy?: string;
  subMenu?: SubMenuItem[];
}

const sideMenuItems: MenuItem[] = [
  {
    name: 'Dashboard',
    to: '/',
    icon: LayoutDashboard,
    policy: 'dashboard.index',
  },
  {
    name: 'Customers',
    to: routes.CUSTOMERS,
    icon: Users,
    policy: 'customers.index',
  },
  {
    name: 'Management',
    icon: NotebookText,
    policy: 'management.index',
    subMenu: [
      {
        title: 'Vouchers',
        to: routes.VOUCHERS,
        icon: Tickets,
        policy: 'management.index',
      },
      {
        title: 'Payments',
        to: routes.PAYMENTS,
        icon: HandCoins,
        policy: 'management.index',
      },
      {
        title: 'Assigned Papers',
        to: routes.ASSIGNED_PAPERS,
        icon: Layers2,
        policy: 'management.index',
      },
    ],
  },
  {
    name: 'Reports',
    icon: ScrollText,
    policy: 'reports.index',
    subMenu: [
      {
        title: 'Customers',
        to: routes.CUSTOMERS_QUERY,
        icon: BookUser,
        policy: 'reports.index',
      },
      {
        title: 'Papers',
        to: routes.PAPER_QUERY,
        icon: Newspaper,
        policy: 'reports.index',
      },
    ],
  },
  {
    name: 'Access',
    icon: Settings,
    policy: 'access.index',
    subMenu: [
      {
        title: 'Users',
        to: routes.USERS,
        icon: Users,
        policy: 'access.index',
      },
      {
        title: 'Roles',
        to: routes.ROLES,
        icon: UserCheck,
        policy: 'access.index',
      },
    ],
  },
  {
    name: 'Master Data',
    icon: DatabaseZap,
    policy: 'masterdata.index',
    subMenu: [
      {
        title: 'Branches',
        to: routes.BRANCHES,
        icon: GitBranch,
        policy: 'masterdata.index',
      },
      {
        title: 'Papers',
        to: routes.PAPERS,
        icon: Layers2,
        policy: 'masterdata.index',
      },
      {
        title: 'Rounds',
        to: routes.ROUNDS,
        icon: Locate,
        policy: 'masterdata.index',
      },
      {
        title: 'Delivery Charge',
        to: routes.DELIVERY_FEE,
        icon: Truck,
        policy: 'masterdata.index',
      },
    ],
  },
];
export default sideMenuItems;
